export const PM_DASHBOARD_PATH = "/product-manager-dashboard";

export const PM_HUBS = {
  api: "/product-manager-dashboard/api-hub",
  faq: "/product-manager-dashboard/faq-hub",
  link: "/product-manager-dashboard/link-hub",
  document: "/product-manager-dashboard/document-hub",
  category: "/product-manager-dashboard/category-hub",
  product: "/product-manager-dashboard/product-hub",
  appKyc: "/product-manager-dashboard/app-kyc-hub",
  gatewaySku: "/product-manager-dashboard/gateway-sku-hub",
  gatewayRoute: "/product-manager-dashboard/gateway-route-hub",
  developerGuide: "/product-manager-dashboard/developer-guide-hub",
  operationalError: "/product-manager-dashboard/operational-error-hub",
  kafkaEvent: "/product-manager-dashboard/kafka-event-hub",
  architectureStandards: "/product-manager-dashboard/architecture-standards-hub",
  knowledgeSearch: "/product-manager-dashboard/knowledge-search",
  productManagementGroup: "/product-manager-dashboard/product-management-groups",
  apiPortfolioIntelligence: "/product-manager-dashboard/api-portfolio-intelligence",
} as const;

export function pmHubAddPath(hub: keyof typeof PM_HUBS): string {
  return `${PM_HUBS[hub]}/add`;
}
